import type { StyledComponent } from 'styled-components'
import styled from 'styled-components'
import blueCheck from '../AudienceEdit/blue_check.png'

const CheckMark: StyledComponent<{| isActive: boolean |}, any, any> = styled.div`
  width: 21px;
  height: 21px;
  border: solid 1px #ccc;
  border-radius: 50%;
  ${({ isActive }) =>
    isActive
      ? `
    border-color: #3699c2;
    background: transparent url(${blueCheck}) no-repeat -2px -1px;
    `
      : ''}
`

export default CheckMark
